import countries from "world-countries";

export default countries.reduce((map, country) => {
  map[country.ccn3] = country.name.common;
  return map;
}, {});
